import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '@commons';
import { Observable } from 'rxjs';
import { GenericResponse } from '@interfaces';

@Injectable({
  providedIn: 'root'
})
export class CancelContractService {

  constructor(
    private configService: ConfigService,
    private httpClient: HttpClient
  ) { }

  public cancelDraft(idBorrador: number): Observable<GenericResponse> {
    return this.httpClient.delete<GenericResponse>(this.configService.getUrl('contrato.cancelDraft', { idBorrador }));
  }

  public cancelContract(codContrato: string): Observable<GenericResponse> {
    return this.httpClient.delete<GenericResponse>(this.configService.getUrl('contrato.cancelContract', { codContrato }));
  }
}
